var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Galeria',{model:{value:(_vm.oportunidade.galeria_arquivo),callback:function ($$v) {_vm.$set(_vm.oportunidade, "galeria_arquivo", $$v)},expression:"oportunidade.galeria_arquivo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }